import { Card, Icon } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import { ADMIN_EMAIL, HELP_EMAIL, HELP_URL } from 'Config';
import BOSFooter from '../routes/BOSFooter';
import styles from './Help.module.css';

const Help = () => {
  let helpLinkButton = (
    <>
      <a
        className={styles.link_button}
        href={HELP_URL}
        target={'_blank'}
        onMouseDown={(e) => e.preventDefault()}
        rel='noreferrer'>
        <Icon icon={'git-repo'} size={44} />
        {'BookStack Documentation'}
      </a>
    </>
  );

  const getEmailButton = (
    emailAddress,
    buttonText,
    subjectText,
    informationText,
  ) => {
    return (
      <div className={styles.help_box}>
        <div className={styles.help_info_text}>
          <Icon
            className={styles.help_info_text}
            style={{ paddingRight: 10, marginTop: 6 }}
            size={24}
            icon={'search'}
          />
          <div className={styles.questions_box}>
            {informationText.map((text, index) => (
              <span key={index}>{text}</span>
            ))}
          </div>
        </div>
        <a
          className={styles.email_link_button}
          href={`mailto:${emailAddress}?subject=${subjectText}`}
          onMouseDown={(e) => e.preventDefault()}>
          <Icon icon={'envelope'} size={30} />
          <span>{buttonText}</span>
        </a>
      </div>
    );
  };

  let emailLinkButton = getEmailButton(
    HELP_EMAIL,
    'Email the developers',
    'Help Needed with HSC BOS',
    [
      'Having problems with the BOS web application?',
      "Have you found a bug or a button that doesn't work?",
      'Did you reach an error page or receive an error message?',
    ],
  );

  let adminEmailLinkButton = getEmailButton(
    ADMIN_EMAIL,
    'Email the admin office',
    'Administration help needed with HSC BOS',
    [
      'Do you need advice or help with an administrative task?',
      'Have a question about logistics?',
      'Need to update your profile or request a new vendor?',
    ],
  );

  return (
    <AppContentView hideBreadcrumbs title={'Help'} footer={<BOSFooter />}>
      <Card>
        <div className={styles.help_card}>
          {helpLinkButton}
          <div className={styles.more_help_header}>Still need help?</div>
          {emailLinkButton}
          {adminEmailLinkButton}
        </div>
      </Card>
    </AppContentView>
  );
};

export default Help;
